export default __webpack_public_path__ + "static/OpenSansLight-c6c8f1742ecb126f0c1b39a343184d04.woff";